function Pollytts(settings_params) {
    // include Polly from aws sdk.
    var Polly = require('aws-sdk/clients/polly');

    // presigner for Polly
    var presigner = new Polly.Presigner({
        region: settings_params.awsRegion,
        credentials: {
            accessKeyId: 'AKIAIEBQN4JWCA35CFFQ',
            secretAccessKey: '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'
        }
    });

    var TTS = {
        self: this,
        playlist: [],
        getAudioUrl: function(msg, VoiceId, ElementId) {
           
            var url = presigner.getSynthesizeSpeechUrl({
                TextType: 'text',
                OutputFormat: 'mp3',
                VoiceId: VoiceId,
                Text: msg
            });
            var audioElement = document.getElementById(ElementId);
            if (!!audioElement) {
                audioElement.src = url;
            }
        }

    }
    return TTS;
}

export default Pollytts;